module.exports = __webpack_public_path__ + "robotboy_2-7ba5066bd00d0dfd25c4b0a9cf7baa80.png";